// removed by extract-text-webpack-plugin
module.exports = {"Base":"Page__Base-3OM_A","Article":"Page__Article-3Fv9W","Header":"Page__Header-2aZtV","Content":"Page__Content-2cW59"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Page/Page.css
 ** module id = 656
 ** module chunks = 0
 **/